module.exports = __webpack_public_path__ + "img/l_s9.4ab14587.png";